const BADGE_SELECTOR = '[data-quiz-diagnostics-nav-badge]'
const LABEL_GROUP_ATTR = 'data-quiz-diagnostics-nav-label-group'

const removeExistingBadges = () => {
  document.querySelectorAll(BADGE_SELECTOR).forEach(node => node.remove())

  document.querySelectorAll(`[${LABEL_GROUP_ATTR}]`).forEach(group => {
    const labelNode = group.querySelector(
      '[data-testid^="TopNav-menu-item-label-"]'
    )
    const parent = group.parentElement

    if (labelNode && parent) {
      parent.insertBefore(labelNode, group)
    }

    group.remove()
  })
}

const createBadgeElement = (badgeLabel: string): HTMLSpanElement => {
  const badge = document.createElement('span')
  badge.setAttribute('data-quiz-diagnostics-nav-badge', 'true')
  badge.setAttribute('aria-label', `${badgeLabel} quizzes due today`)
  badge.textContent = badgeLabel
  badge.style.boxSizing = 'border-box'
  badge.style.display = 'inline-flex'
  badge.style.alignItems = 'center'
  badge.style.justifyContent = 'center'
  badge.style.width = '25px'
  badge.style.minWidth = '25px'
  badge.style.maxWidth = '25px'
  badge.style.height = '17px'
  badge.style.padding = '0'
  badge.style.borderRadius = '9px'
  badge.style.background = '#ea4335'
  badge.style.color = '#ffffff'
  badge.style.fontSize = '10px'
  badge.style.fontWeight = '700'
  badge.style.lineHeight = '17px'
  badge.style.flexShrink = '0'
  badge.style.overflow = 'hidden'
  return badge
}

/** Match client design: icon | Spaced Rep. Quizzes [25x17 badge] on one line. */
export const injectQuizDiagnosticsMenuBadge = (
  label: string,
  badgeLabel?: string
) => {
  removeExistingBadges()

  if (!badgeLabel) {
    return
  }

  const inject = () => {
    const labelNodes = document.querySelectorAll(
      '[data-testid^="TopNav-menu-item-label-"]'
    )

    for (const labelNode of labelNodes) {
      if (!(labelNode instanceof HTMLElement)) {
        continue
      }

      if (labelNode.textContent?.trim() !== label) {
        continue
      }

      const labelWrapper = labelNode.parentElement

      if (!labelWrapper || labelWrapper.querySelector(BADGE_SELECTOR)) {
        break
      }

      const menuItem = labelWrapper.parentElement
      if (menuItem instanceof HTMLElement) {
        menuItem.style.overflow = 'visible'
      }

      labelWrapper.style.alignItems = 'center'
      labelWrapper.style.minWidth = '0'
      labelWrapper.style.flex = '1'

      // Keep full label visible (TopNav defaults to ellipsis).
      labelNode.style.overflow = 'visible'
      labelNode.style.textOverflow = 'clip'
      labelNode.style.flexShrink = '0'

      const labelGroup = document.createElement('span')
      labelGroup.setAttribute(LABEL_GROUP_ATTR, 'true')
      labelGroup.style.display = 'inline-flex'
      labelGroup.style.alignItems = 'center'
      labelGroup.style.gap = '6px'
      labelGroup.style.flexShrink = '0'
      labelGroup.style.minWidth = '0'

      labelWrapper.insertBefore(labelGroup, labelNode)
      labelGroup.append(labelNode, createBadgeElement(badgeLabel))
      break
    }
  }

  // Menu opens after click; wait until labels are in the DOM.
  requestAnimationFrame(() => {
    inject()
    requestAnimationFrame(inject)
  })
}
